import * as React from 'react'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { StaticImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import { ProductImage } from '../CategoryImage'
import InputField from '../form/InputField'
import USD from '../../helpers/NumberHelper'
import finalPrice from '../../helpers/product/finalPrice'
import FormWrapper from '../form/FormWrapper'
import useFormState from '../form/hooks/useFormState'
import { hidePopup } from '../../state/popupForms'
import isEmail from '../form/validators/isEmail'
import isPhone from '../form/validators/isPhone'
import ProductTitle from '../products/ProductTitle'
import SubmitButton from '../form/SubmitButton'

const AskAQuestion = ({ product, category }) => {
  const dispatch = useDispatch()
  const closeAskAQuestion = useCallback(() => {
    dispatch(hidePopup())
  }, [])
  const handleKeyPress = e => {
    switch (e.key) {
      case 'Escape':
        dispatch(hidePopup())
        break
      default:
        break
    }
  }
  React.useEffect(() => {
    if (typeof window === 'undefined') return
    window.addEventListener('keydown', handleKeyPress)
    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [])
  // NOTE: we skip 2nd argument on purpose, we don't need it
  const [form, setForm, updateForm] = useFormState({
    name: '',
    phone: '',
    email: '',
    consent: true,
    message: '',
    product: {
      sku: product.sku,
      name: product.title,
      price: finalPrice(product),
      image: product.image,
      url: product.url,
    },
  })
  const [, /*formSubmitted*/ setFormSubmitted] = React.useState(false)
  const [clicked, setClicked] = React.useState(false)
  const [error, setError] = React.useState(false)
  const [progress, setProgress] = React.useState(0)
  React.useEffect(() => {
    if (!clicked) return
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev < 1) {
          return prev + 0.01
        } else {
          // return 0
          clearInterval(interval)
          setFormSubmitted(true)
          return 1
        }
      })
    }, 50)
    return () => clearInterval(interval)
  }, [clicked, setProgress, setFormSubmitted])

  React.useEffect(() => {
    setForm(f => ({
      ...f,
      product: {
        sku: product.sku,
        name: product.title,
        price: finalPrice(product),
        image: product.image,
        url: product.url,
      },
    }))
    // console.log('product', product)
  }, [product, updateForm])

  const onChangeHandler = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.checked }))
  }

  return (
    <div className="fade-in-now fixed top-0 left-0 flex h-full w-full items-center justify-center lg:h-screen z-popup bg-white md:bg-transparent backdrop-blur-sm">
      <div className="fade-in-later fixed inset-0 pt-10  p-5 shorter768:rounded-none shorter768:h-screen shorter768:max-h-screen shorter768:w-screen shorter768:max-w-[100vw] lg:relative z-20 w-full md:max-w-[800px] bg-white shadow-lg md:rounded-lg md:max-h-[85vh] m-auto overflow-auto md:pt-5 ">
        <button
          onClick={closeAskAQuestion}
          className="absolute top-10 md:top-5 right-5 h-8 w-8 rounded-full border-2 border-gray-300 text-lg font-black text-gray-300 hover:border-gray-400 hover:bg-gray-100 hover:text-gray-400"
        >
          &#10005;
        </button>
        <h2 className="pb-5 text-center text-3xl font-black text-gray-500">ASK A QUESTION</h2>
        <p className=" mx-auto w-full max-w-[500px] text-center text-sm leading-relaxed text-gray-600 md:text-base">
          Experienced professionals are ready to answer your questions Fill out the form below and
          one of us will respond quickly.
        </p>
        <section className="mx-auto grid max-w-[300px] grid-flow-col grid-cols-2 grid-rows-[1fr_auto] gap-5 overflow-auto py-5 text-center text-sm">
          <div className="mx-auto aspect-square w-full max-w-[300px] overflow-hidden rounded-full border border-gray-300 ">
            <StaticImage
              src="../../images/rich-make-an-offer.jpeg"
              alt="Ask Rich a Question"
              sizes="(100vw - 2rem) 25vw, 300px"
              imgStyle={{ objectFit: 'cover' }}
              className="w-full h-full aspect-square"
            />
          </div>
          RICH
          <div className="mx-auto aspect-square w-full max-w-[300px] overflow-hidden rounded-full border border-gray-300 ">
            <StaticImage
              src="../../images/viktoria-livechat.jpeg"
              alt="Ask Viktoria a Question"
              sizes="(100vw - 2rem) 25vw, 300px"
              imgStyle={{ objectFit: 'cover' }}
              className="w-full h-full aspect-square"
            />
          </div>
          VIKTORIA
        </section>

        <FormWrapper
          form={form}
          name={'Ask a Question'}
          action={() => {
            closeAskAQuestion()
          }}
          onSubmit={() => {
            setClicked(true)
          }}
          method={'POST'}
          className="grid grid-cols-2 grid-rows-[1fr_auto] m-auto max-w-[800px] "
          useSubmitAnimation={false}
          onSubmitError={err => {
            setProgress(1)
            setError(err)
          }}
          minimumTimeout={1250}
          conversionEventName="ask_for_details"
        >
          <div className="col-span-2 row-span-2 flex flex-row m-auto max-w-[400px] md:col-span-1 md:row-span-1 md:flex-col">
            <div className="md:w-10/12 mx-auto max-w-[250px] w-28 h-28 md:h-auto aspect-square overflow-hidden p-3 ">
              <ProductImage
                image={product.image}
                product={product}
                loading={'eager'}
                className={'w-full h-full aspect-square'}
                imgStyle={{ objectFit: 'contain' }}
              />
            </div>
            <div className="w-full grid grid-rows-[1fr_2.5rem]  grid-cols-[1fr_auto] justify-start items-center">
              <div className="leading-none col-span-2 line-clamp-3 pr-2">
                <ProductTitle product={product} category={category} showRef={false} />
              </div>
              {/* This is the price for the mobile top bar component */}
              <p className={' w-full mx-auto text-gray-700 text-xl text-left font-bold h-10 '}>
                {USD(finalPrice(product))}
              </p>
            </div>
          </div>
          <div className="relative pb-20 col-span-2 row-span-2 my-auto md:col-span-1 md:row-span-1">
            <InputField
              errorMessage=""
              name={'name'}
              label={'Name'}
              form={form}
              onChange={updateForm}
              required={true}
            />
            <InputField
              errorMessage=""
              name={'phone'}
              label={'Telephone'}
              form={form}
              validator={isPhone}
              onChange={updateForm}
              required={true}
            />
            <InputField
              errorMessage=""
              name={'email'}
              label={'E-Mail'}
              form={form}
              validator={isEmail}
              onChange={updateForm}
              required={true}
            />
            <InputField
              errorMessage=""
              name={'message'}
              type="textarea"
              rows={4}
              label={'Message'}
              form={form}
              onChange={updateForm}
              required={true}
            />
            <div className="col-span-1 h-full">
              <label className="text-xs text-gray-500 flex flex-row gap-3 items-start my-2">
                <input
                  type="checkbox"
                  name="consent"
                  checked={form['consent']}
                  onChange={onChangeHandler}
                />
                I agree to receive updates and follow-up messages about my inquiries via text and
                email.
              </label>
              <SubmitButton
                className={'z-50 '}
                progress={progress}
                submit={clicked}
                error={error}
                // onClick={() => setClicked(true)}
              />
            </div>
            {/* <button className="mt-2 rounded-md bg-red-600 px-8 py-2 font-bold text-white hover:bg-red-800">
              SEND
            </button> */}
          </div>
        </FormWrapper>
      </div>
      <button
        onClick={closeAskAQuestion}
        className="fixed -top-11 z-1 flex h-[calc(100vh+10%)] w-screen items-center justify-center bg-black opacity-30 cursor-alias"
      />
    </div>
  )
}

AskAQuestion.propTypes = {
  product: PropTypes.object.isRequired,
  category: PropTypes.object.isRequired,
}

export default AskAQuestion
